import createFastContext from "./createFastContext";

type StoreType = {
  models: Queries.Model[];
  preFilteredModel: string | null;
  selectedModels: string[];
  brands: Queries.Brand[];
  preFilteredBrand: string | null;
  selectedBrands: string[];
  page: number;
  searchQuery: string;
}

export const initialStore: StoreType = {
  models: [],
  preFilteredModel: null,
  selectedModels: [],
  brands: [],
  preFilteredBrand: null,
  selectedBrands: [],
  searchQuery: '',
  page: 1,
}

export const { Provider, useStore } = createFastContext(initialStore)
